export function PrefSearchSkeleton() {
	return (
		<div className="animate-pulse w-full max-w-[746px]">
			{/* Divider skeleton */}
			<div className="mt-6 mb-6 flex items-center justify-center">
				<div className="flex-1 h-px bg-neutral-200"></div>
				<div className="px-4 w-6 h-4 bg-neutral-200 rounded"></div>
				<div className="flex-1 h-px bg-neutral-200"></div>
			</div>

			{/* Fixed content area - match actual component structure */}
			<div className="min-h-[140px]">
				{/* Label skeleton */}
				<div className="mb-4">
					<div className="h-4 bg-neutral-200 rounded w-48"></div>
				</div>

				{/* Preferences list skeleton */}
				<div className="mb-6">
					<div className="flex flex-col gap-4">
						{/* Scrollable preferences container skeleton */}
						<div className="flex gap-4 overflow-hidden">
							{/* Individual preference item skeletons - matching PreferenceSelect hero layout */}
							{Array.from({ length: 1 }).map((_, index) => (
								<div
									key={index}
									className="inline-flex items-center gap-3 px-4 h-[56px] rounded-xl border-2 border-black/30 bg-white min-w-[140px] animate-pulse transition-colors hover:border-black/40"
								>
									<div className="w-5 h-5 bg-neutral-700/20 rounded"></div>
									<div className="w-16 h-4 bg-neutral-700/30 rounded"></div>
								</div>
							))}
							{/* Add preference button skeleton */}
							<div className="inline-flex items-center gap-2 px-6 h-[56px] rounded-xl border-2 border-dashed border-black/20 bg-white min-w-[140px] animate-pulse transition-colors hover:border-black/30">
								<div className="w-5 h-5 bg-neutral-700/20 rounded"></div>
								<div className="w-14 h-4 bg-neutral-700/30 rounded"></div>
							</div>
						</div>

						{/* Search buttons skeleton - match new layout structure exactly */}
						<div className="w-full flex flex-col sm:flex-row gap-3 sm:gap-4">
							<div className="flex-1 h-[56px] min-h-[56px] bg-neutral-200 rounded-xl min-w-[200px]"></div>
							<div className="flex-shrink-0 h-[56px] min-h-[56px] bg-neutral-200 rounded-xl min-w-[160px]"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
